export const ENVIRONMENT = {
  development: "development",
  qa: "qa",
  production: "production",
};

export const TOKEN_RESPONSE = {
  access_token_expirado: "TokenExpired",
  refresh_token_valido: "TokenOK",
  refresh_token_invalido: "RefreshTokenNotValid",
};

export const LOCAL_STORAGE = {
  ESTADO_SESION: {
    KEY: "estadoSesion",
    VALUE: "ACTIVA",
  },
  PSS_ACTIVO: {
    KEY: "pssActivo",
  },
  FECHA_ULTIMA_ENCUESTA: {
    KEY: "fechaUltimaEncuesta",
  },
};

export const MINUTOS_INACTIVIDAD = 20;

export const COOKIE_EXPIRATION_DAYS = {
  one: 1,
  two: 2,
  three: 3,
};

export const COOKIE_NAME = {
  access_token: "atbffws",
  refresh_token: "rtbffws",
  session_getter: "ssgws",
};

export const SEARCH_TYPE = {
  all: "all",
  lastTwoMonth: "lastTwoMonth",
};

export const NCF_MAX_LENGTH = {
  typeB: 11,
  typeE: 13,
};

export const NCF_TYPE = {
  typeB: "b",
  typeE: "e",
};

export const EMPRESA = {
  PRIMERA: {
    CODIGO: "96",
    NOMBRE: "Primera Ars",
  },
  HUMANO: {
    CODIGO: "30",
    NOMBRE: "Humano Seguros",
  },
};

export const PROGRAMA = {
  PROMOCION_PREVENCION: {
    CODIGO : "PYP",
    DESCRIPCION: "Promoción y Prevención"
  }
};

export const DATE_FORMATS = {
  middledash_dmy: "DD-MM-YYYY",
  middledash_ymd: "YYYY-MM-DD",
  slash: "DD/MM/YYYY",
};

export const KEY_TYPE = {
  enter: "Enter",
};

export const PSS_TYPE = {
  MEDICO: "MEDICO",
  NO_MEDICO: "NO_MEDICO",
};

export const DOCUMENT_TYPE_NAME = {
  CEDULA: "Cedula",
  CEDULA_ACENTUADA: "Cédula",
  PASAPORTE: "Pasaporte",
  RNC: "Rnc",
};

export const DOCUMENT_TYPE_ID = {
  CEDULA: 1,
  PASAPORTE: 2,
  RNC: 3,
};

export const PSS_PST = {
  SI_EMITE_COMPROBANTE: "S",
  NO_EMITE_COMPROBANTE: "N",
};

export const TOKEN_TYPE = {
  BEARER: "Bearer",
};

export const TIME_SCALE = {
  mes: "month",
  dia: "day",
  semana: "week",
  anio: "year",
};

export const QUERY_RANGE = {
  uno: 1,
  dos: 2,
  tres: 3,
  cuatro: 4,
};

export const DOWNLOAD_TYPE = {
  true: true,
  false: false,
};

export const ENCUESTA_CES_HORARIO = {
  FECHA_HORA_INICIO: "15:00",
  FECHA_HORA_FIN: "17:00",
};
